const indexItems = [
  { title: '娱乐圈周报', desc: '每周精选十大热门事件', icon: 'ri-newspaper-line', color: 'primary' },
  { title: '明星动态', desc: '追踪明星最新行程与动态', icon: 'ri-user-star-line', color: 'accent' },
  { title: '综艺大盘点', desc: '热门综艺节目全梳理', icon: 'ri-tv-line', color: 'primary' },
  { title: '影视推荐', desc: '每周必看影视作品清单', icon: 'ri-film-line', color: 'accent' },
  { title: '网红观察', desc: '网红圈最新趋势与话题', icon: 'ri-live-line', color: 'primary' },
  { title: '音乐风向标', desc: '新歌发布与音乐节资讯', icon: 'ri-music-line', color: 'accent' },
  { title: '时尚潮流', desc: '明星穿搭与时尚解析', icon: 'ri-shirt-line', color: 'primary' },
  { title: '社交热议', desc: '平台热门帖子和话题', icon: 'ri-chat-1-line', color: 'accent' },
  { title: '深度专题', desc: '吃瓜话题深度分析与解读', icon: 'ri-article-line', color: 'primary' },
];

export default function IndexSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">专题合集</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              按主题分类浏览吃瓜内容，快速定位你最感兴趣的专题方向
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, idx) => (
              <a
                key={idx}
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg flex-shrink-0 ${
                  item.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-700'
                }`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base text-foreground-800 font-medium mb-0.5 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400">{item.desc}</p>
                </div>
                <div className="flex-shrink-0 text-foreground-300 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}